import React, { useState, useEffect } from 'react';
import { login, getPublicLaboratories } from '../api';

function Login({ onLogin }) {
  const [laboratories, setLaboratories] = useState([]);
  const [labCode, setLabCode] = useState('');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchLaboratories();
  }, []);

  const fetchLaboratories = async () => {
    try {
      const response = await getPublicLaboratories();
      setLaboratories(response.data);
    } catch (err) {
      console.error('Error fetching laboratories:', err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(labCode, username, password);
      onLogin(response.data.user, response.data.token);
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>Welcome Back!</h2>
        <p>Sign in to manage your research publications</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="labCode">Laboratory Code</label>
            <select
              id="labCode"
              value={labCode}
              onChange={(e) => setLabCode(e.target.value)}
              className="form-control"
              required
            >
              <option value="">-- Select Laboratory Code --</option>
              <option value="ADMIN">ADMIN</option>
              {laboratories.map(lab => (
                <option key={lab._id} value={lab.code}>
                  {lab.code}
                </option>
              ))}
            </select>
            <small style={{ color: '#666', fontSize: '0.85em', marginTop: '5px', display: 'block' }}>
              Select your laboratory code (Admins select "ADMIN")
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              className="form-control"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              className="form-control"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
